var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"general-node-settings"},[_c('EnterNodeMainPreset',{attrs:{"presets":_vm.presets,"screens":_vm.screensCurrentNode,"nodeId":_vm.nodeId}}),(_vm.presets)?_c('GeneralPresets',{attrs:{"presets":_vm.presets,"selectedPreset":_vm.selectedPreset},on:{"getNodePreset":_vm.getNodePreset}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }